import React from 'react';

interface TextAreaFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  maxLength,
  rows = 4
}) => (
  <textarea
    id={id}
    name={id}
    value={value || ''}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    maxLength={maxLength}
    rows={rows}
    className="cg-textarea"
  />
);

export default TextAreaField;